<script>
  import { scale } from "svelte/transition";
  import { onMount, createEventDispatcher } from "svelte";
  import { getLocal } from "../../stores/store";

  export let weather;
  export let city;

  let icon = "113"; //`./images/weather-icons/${timeOfDay}/${icon}.png`
  let time = localStorage.getItem("hour");
  let timeOfDay = time > 6 || time < 18 ? "day" : "night";
  let regex = /[1-9]\d\d/g;
  let zip = "";

  const dispatch = createEventDispatcher();
  const handleSearch = () => {
    if (zip === getLocal("zip")) {
      dispatch("display");
    }
    localStorage.setItem("zip", JSON.stringify(zip));
    dispatch("search", { zip });
  };

  let today = new Date();
  $: strDate = "";
  onMount(() => {
    today = new Date();
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];

    let day = days[today.getDay()];
    let month = months[today.getMonth()];
    let date = today.getDate();
    strDate = `${day} ${month} ${date}`;
  });
</script>

<style>
  .weather-card {
    display: grid;
    justify-items: center;
    text-align: center;
    background-color: rgb(255, 255, 255, 0.8);
    color: #494d4e;
    border-radius: 5px;
    box-shadow: -5px 19px 38px rgba(0, 0, 0, 0.3),
      -5px 15px 12px rgba(0, 0, 0, 0.22);
    grid-gap: 0.5em;
    padding: 1vw;
  }

  form {
    display: grid;
    width: 100%;
  }

  .input {
    display: flex;
    justify-content: center;
  }

  input {
    width: 80px;
  }

  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
    text-align: center;
    border-radius: 5px;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    text-align: center;
  }

  button {
    margin-left: 10px;
    border: 1px inset rgba(255, 255, 255, 0.25);
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.25) inset;
    background-color: rgb(33, 157, 168);
    cursor: pointer;
    background: linear-gradient(
        top,
        rgba(255, 255, 255, 0.7),
        transparent,
        rgba(255, 255, 255, 0.7)
      ),
      linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));
    background: -webkit-linear-gradient(
        top,
        rgba(255, 255, 255, 0.7),
        transparent,
        rgba(255, 255, 255, 0.7)
      ),
      -webkit-linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));
    border-radius: 5px;
    text-decoration: none;

    transition: all 0.1s linear;
    position: relative;
    display: grid;
    align-items: center;
  }

  button:hover {
    background: linear-gradient(
      top,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255),
      rgba(255, 255, 255, 0.5)
    );
    background: -webkit-linear-gradient(
      top,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255),
      rgba(255, 255, 255, 0.5)
    );
    color: rgb(73, 77, 78);
    filter: sepia(1) hue-rotate(130deg) saturate(1);
  }

  button:active,
  span:active {
    top: 1px;
  }

  .gradient-text {
    transition: all 0.1s linear;
    position: relative;
    color: #fff;
    font-size: 1.8vh;
    font-weight: 600;
    text-shadow: -2px 2px 2px rgb(73, 77, 78, 0.2),
      -5px 5px 5px rgb(73, 77, 78, 0.3);
  }

  button:hover > span {
    background: linear-gradient(
      top,
      #1098b7,
      #0bbdde,
      #1098b7,
      #0bbdde,
      #1098b7
    );
    background: -webkit-linear-gradient(
      top,
      #1098b7,
      #0bbdde,
      #1098b7,
      #0bbdde,
      #1098b7
    );
    text-shadow: 1px 2px 3px rgba(238, 238, 238, 0.774),
      0 0 0 rgba(73, 77, 78, 0.2), 1px 2px 3px rgb(73, 77, 78);
    color: rgb(73, 77, 78);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  h2 {
    margin-bottom: -20px;
  }

  .tempWrap {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
  }

  .temp {
    display: grid;
    justify-items: flex-start;
    justify-content: flex-start;
    align-content: flex-end;
    width: 100%;
    height: 100%;
  }

  h1 {
    font-size: 4vh;
  }

  h3 {
    font-size: 2.5vh;
  }

  p {
    text-align: left;
  }

  .right {
    display: grid;
    justify-items: flex-end;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    padding-left: 1vw;
  }

  img {
    width: 100px;
    position: relative;
    left: 15px;
    top: 6px;
  }

  .minmax {
    align-self: flex-end;
  }

  .regex {
    display: none;
  }
</style>

<div in:scale={{ duration: 700 }} class="weather-card">
  <form>
    <label for="zip">Search by Zip Code</label>
    <div class="input">
      <input bind:value={zip} type="number" placeholder="12345" />
      <button on:click|preventDefault={handleSearch} type="submit">
        <span class="gradient-text">Search</span>
      </button>
    </div>
  </form>
  {#each weather as { forecast, current }, idx}
    <div class="regex">{(icon = current.condition.icon.match(regex)[0])}</div>
    <h2 style="margin-bottom: -10px;">{strDate}</h2>
    <h2>{city}</h2>
    <div class="tempWrap">
      <div class="temp">
        <h1>{current.temp_f}&#176;</h1>
        <h3>{current.condition.text}</h3>
        <p>Feels like {Math.round(current.feelslike_f)}&#176;</p>
      </div>
      <div class="right">
        <img
          src={`./images/weather-icons/${timeOfDay}/${icon}.png`}
          alt={current.condition.text} />
        <p class="minmax">
          {forecast.forecastday[idx].day.mintemp_f}&#176;/{forecast.forecastday[idx].day.maxtemp_f}&#176;
        </p>
      </div>
    </div>
  {/each}
</div>
